var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18.5C36 28.4411 27.9411 36.5 18 36.5C8.05887 36.5 0 28.4411 0 18.5C0 8.55887 8.05887 0.5 18 0.5C27.9411 0.5 36 8.55887 36 18.5ZM18 29.5C17.4477 29.5 17 29.0523 17 28.5V19.5H8C7.44772 19.5 7 19.0523 7 18.5C7 17.9477 7.44772 17.5 8 17.5H17V8.5C17 7.94772 17.4477 7.5 18 7.5C18.5523 7.5 19 7.94772 19 8.5V17.5H28C28.5523 17.5 29 17.9477 29 18.5C29 19.0523 28.5523 19.5 28 19.5H19V28.5C19 29.0523 18.5523 29.5 18 29.5Z",
    fill: "#74B743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.dc195e24499edf6e56a06cc86edaa2c3.svg";
export { ForwardRef as ReactComponent };